import React from 'react';
import { useAppSelector } from 'reducers/useAppSelector';
import { getUserContext } from 'selectors/user/userSelectors';

import { notDesktop } from '@zola-helpers/client/dist/es/util/responsive';
import RegistryAssetDesktop from 'assets/images/invitations/plp-tiles/Asset-registry-hero-desktop@2x.svg';

import { handlePostAuthRegLanding } from 'util/experiments/registryLandingUtils';

import {
  Container,
  IllustrationContainer,
  Illustration,
  Content,
  Title,
  Text,
  StyledCTA,
  ComponentSize,
} from './styles';

type RegistryAdTileProps = {
  size?: ComponentSize;
};

const RegistryAdTile = ({ size }: RegistryAdTileProps): JSX.Element => {
  const userContext = useAppSelector(getUserContext);

  const handleCreateRegistry = () => {
    handlePostAuthRegLanding();
  };

  return (
    <Container size={size}>
      <IllustrationContainer>
        <Illustration src={RegistryAssetDesktop} />
      </IllustrationContainer>
      <Content>
        <Title>Don&apos;t forget to register!</Title>
        <Text>It&apos;s never too early (or too late!) to add gifts to your registry.</Text>
        <StyledCTA
          size={notDesktop() ? 'small' : 'medium'}
          colorway="lilac"
          onClick={() => {
            // If pre auth, redirect to onboard
            if (userContext?.is_guest) {
              return window.location.assign('/onboard/new');
            }
            // If post auth but no registry account
            // We need to create a registry BU account first
            if (!userContext?.registry_account) {
              return handleCreateRegistry();
            }
            // If post auth with a registry account
            return window.location.assign('/registry/checklist');
          }}
        >
          Start your registry
        </StyledCTA>
      </Content>
    </Container>
  );
};

export default RegistryAdTile;
